import qs from 'qs';
import axios from 'axios';
import Jsona from 'jsona';

const url = process.env.VUE_APP_API_BASE_URL;
const jsona = new Jsona();

function list(params) {
    let options = {
        params: params,
        paramsSerializer: function (params) {
            return qs.stringify(params, {encode: false});
        },
        headers: {
            'Accept': 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json',
        },
    };

    return axios.get(`${url}/labourerSchedules`, options)
        .then(response => {
            console.log('labourer-schedule-service:list', response.data);
            return {
                list: jsona.deserialize(response.data),
                meta: response.data.meta
            };
        });
}

function get(id) {
    const options = {
        headers: {
            'Accept': 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json',
        }
    };

    return axios.get(`${url}/labourerSchedules/${id}?include=skills,parents,educations.exam`, options)
        .then(response => {
            let vendors = jsona.deserialize(response.data);
            delete vendors.links;
            return vendors;
        });
}


function view(params) {
    const options = {
        headers: {
            'Accept': 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json',
        }
    };

    return axios.get(`${url}/labourerSchedules/${params.id}?include=${params.include}`, options)

        .then(response => {
            let labourerSchedule = jsona.deserialize(response.data);
            delete labourerSchedule.links;
            return labourerSchedule;
        });
}


function show(id) {
    const options = {
        headers: {
            'Accept': 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json',
        }
    };

    return axios.get(`${url}/labourerSchedules/${id}`, options)
        .then(response => {
            let vendors = jsona.deserialize(response.data);
            delete vendors.links;
            return vendors;
        });
}

function add(labourerSchedule) {
    const payload = jsona.serialize({
        stuff: labourerSchedule,
        includeNames: null
    });

    const options = {
        headers: {
            'Accept': 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json',
        }
    };

    return axios.post(`${url}/labourerSchedules`, payload, options)
        .then(response => {
            return jsona.deserialize(response.data);
        });
}

function update(labourerSchedule) {
    const payload = jsona.serialize({
        stuff: labourerSchedule,
        includeNames: []
    });

    const options = {
        headers: {
            'Accept': 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json',
        }
    };

    return axios.patch(`${url}/labourerSchedules/${labourerSchedule.id}`, payload, options)
        .then(response => {
            return jsona.deserialize(response.data);
        });
}

function destroy(id) {
    const options = {
        headers: {
            'Accept': 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json',
        }
    };

    return axios.delete(`${url}/labourerSchedules/${id}`, options);
}

function reset(id, comment) {
    console.log('RESET CALLED', id, comment);   // <-- add this
    const formData = new URLSearchParams();
    formData.append("comment", comment);

    return axios.post(
        `${url}/labourer/supervisor/reset/${id}`,
        formData,
        {
            headers: {
                "Content-Type": "application/x-www-form-urlencoded"
            }
        }
    );
}


function upload(labourerSchedule, image) {
    const bodyFormData = new FormData();
    bodyFormData.append('attachment', image);
    console.log(bodyFormData);
    return axios.post(`${url}/uploads/items/${labourerSchedule.id}/image`, bodyFormData)
        .then(response => {
            return response.data.url;
        });
}


function checkin(labourerSchedule) {
    const payload = jsona.serialize({
        stuff: labourerSchedule,
        includeNames: []
    });

    const options = {
        headers: {
            'Accept': 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json',
        }
    };

    return axios.get(`${url}/labourerSchedule/checkin/${labourerSchedule.id}`, payload, options)
        .then(response => {
            return jsona.deserialize(response.data);
        });
}

function checkinSupervisor(labourerSchedule) {
    const formData = new URLSearchParams();

    if (labourerSchedule.checkin_supervisor_reaction !== undefined) {
        formData.append('checkin_supervisor_reaction', labourerSchedule.checkin_supervisor_reaction);
    }

    if (labourerSchedule.checkin_supervisor_comment !== undefined) {
        formData.append('checkin_supervisor_comment', labourerSchedule.checkin_supervisor_comment);
    }

    return axios.post(`${url}/labourer/checkin/supervisor/${labourerSchedule.id}`, formData, {
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
        }
    }).then(response => {
        let labourerSchedule = jsona.deserialize(response.data);
        delete labourerSchedule.links;
        return labourerSchedule;
    });
}

function checkoutSupervisor(labourerSchedule) {
    const formData = new URLSearchParams();

    if (labourerSchedule.checkout_supervisor_reaction !== undefined) {
        formData.append('checkout_supervisor_reaction', labourerSchedule.checkout_supervisor_reaction);
    }

    if (labourerSchedule.checkout_supervisor_comment !== undefined) {
        formData.append('checkout_supervisor_comment', labourerSchedule.checkout_supervisor_comment);
    }

    return axios.post(`${url}/labourer/checkout/supervisor/${labourerSchedule.id}`, formData, {
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
        }
    }).then(response => {
        let labourerSchedule = jsona.deserialize(response.data);
        delete labourerSchedule.links;
        return labourerSchedule;
    });
}

function checkout(labourerSchedule) {
    const formData = new URLSearchParams();

    if (labourerSchedule.checkout_comment !== undefined) {
        formData.append('checkout_supervisor_reaction', labourerSchedule.checkout_comment);
    }

    return axios.post(`${url}/labourer/checkout/manual/supervisor/${labourerSchedule.id}`, formData, {
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
        }
    }).then(response => response.data);
}


function supervisorList(params) {
    let options = {
        params: params,
        paramsSerializer: function (params) {
            return qs.stringify(params, {encode: false});
        },
        headers: {
            'Accept': 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json',
        },
    };

    return axios.get(`${url}/labourerSchedules/supervisor-list`, options)
        .then(response => {
            console.log('labourer-schedule-service:supervisorList', response.data);
            return {
                list: jsona.deserialize(response.data.data),
                meta: response.data.meta
            };
        });
}

function manualCheckIn(payload) {
    const formData = new URLSearchParams();
    formData.append('check_in_time', payload.check_in_time);
    formData.append('check_in_type', payload.check_in_type || 'manual');
    if (payload.remarks) {
        formData.append('remarks', payload.remarks);
    }

    return axios.post(`${url}/labourerSchedules/${payload.id}/manual-check-in`, formData, {
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
        }
    }).then(response => response.data);
}

function manualCheckOut(payload) {
    const formData = new URLSearchParams();
    formData.append('check_out_time', payload.check_out_time);
    formData.append('check_out_type', payload.check_out_type || 'manual');
    if (payload.remarks) {
        formData.append('remarks', payload.remarks);
    }

    return axios.post(`${url}/labourerSchedules/${payload.id}/manual-check-out`, formData, {
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
        }
    }).then(response => response.data);
}

function syncPunchs(payload) {
    return axios.post(`${url}/labourerSchedule/findPunch/${payload.id}`)
        .then(response => {
            return jsona.deserialize(response.data);
        });

}

function generateShiftAssignmentPdf(filters) {
    return axios.post(
        `${url}/reports/shift-assignment/pdf`,
        filters,
        {
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            }
        }
    );
}
function shiftAssignmentPdfStatus(reportId) {

    return axios.get(
        `${url}/reports/shift-assignment/${reportId}/status`
    ).then(response => response.data);

}
function previewShiftAssignmentPdf(reportId) {

    return axios.get(
        `${url}/reports/shift-assignment/${reportId}/preview`,
        {
            responseType: 'blob',
            headers: {
                Accept: 'application/pdf'
            }
        }
    );

}
function downloadShiftAssignmentPdf(reportId) {
    return axios.get(
        `${url}/reports/shift-assignment/${reportId}/download`,
        {
            headers: {
                'Accept': 'application/pdf'
            },
            responseType: 'blob'
        }
    );
}

export default {
    list,
    get,
    view,
    show,
    add,
    update,
    destroy,
    upload,
    checkin,
    checkinSupervisor,
    checkoutSupervisor,
    checkout,
    reset,
    supervisorList,
    manualCheckIn,
    manualCheckOut,
    syncPunchs,
    generateShiftAssignmentPdf,
    shiftAssignmentPdfStatus,
    previewShiftAssignmentPdf,
    downloadShiftAssignmentPdf
};

